<template>
    <div class="container" v-if="padrao_vida">

        <div class="simulator-box card-panel">

            <h2 class="simulator-title mb-0" :class="{loaded: cliente, 'with-animation' : carregando}">Padrão de Vida</h2>
            <p class="grey-text mb-5">Valores baseados em gastos mensais</p>

            <input-simulador input-type="price" label="Gastos Fixos:" @input="salvar" v-model="padrao_vida.gastos_fixos" />

            <input-simulador input-type="price" label="Lazer:" @input="salvar" v-model="padrao_vida.lazer" />

            <input-simulador input-type="price" label="Seguros e Previdência:" @input="salvar" v-model="padrao_vida.seguro_previdencia" />

            <input-simulador
                label="Outros"
                input-type="price"
                @input="salvar" v-model="padrao_vida.outros" />

            <div class="section">
                <div class="flex-row middle-xs">
                    <strong class="col-xs-6">TOTAL:</strong>
                    <strong class="col-xs-6 end-xs">
                        {{ soma | dinheiro }}
                    </strong>
                </div>
            </div>
        </div>

        <div class="simulator-box card-panel">

            <input-simulador label="Percentual do Cliente" @input="salvar" v-model="padrao_vida.porcentagem_responsabilidade" input-type="percent">
                <svg-percentage class="svg-icon" slot="icon"/>
            </input-simulador>

            <div class="section">
                <div class="flex-row middle-xs">
                    <strong class="col-xs-6">
                        TOTAL QUE É SUA RESPONSABILIDADE:
                    </strong>
                    <strong class="col-xs-6 end-xs">
                        {{ somaPorcentagem | dinheiro }}
                    </strong>
                </div>
            </div>
        </div>

        <div class="simulator-box card-panel">
            <input-simulador label="Prazo" description="Tempo necessário (em anos) para proteger sua família." icon="schedule" @input="salvar" v-model="padrao_vida.anos_protecao_familia" input-type="number"></input-simulador>
        </div>


        <div class="simulator-box card-panel">
            <div class="flex-row middle-xs">
                <strong class="col-xs-6">
                    TOTAL:
                </strong>
                <strong class="col-xs-6 end-xs">
                    {{ somaPrazo | dinheiro }}
                </strong>
            </div>
        </div>

        <footer-simulador :loading.sync="carregando" :action="concluir" />
    </div>
</template>


<script>

import {put, get} from "@/helpers/api";
import "@/../static/assets/css/custom/flex.css";
import debounce from "lodash/debounce";

import InputSimulador from '@/components/common/InputSimulador.vue';
import SvgPercentage from '@/components/common/svg/SvgPercentage.vue';
import FooterSimulador from "@/components/common/FooterSimulador.vue";

export default {

    components: {InputSimulador, SvgPercentage, FooterSimulador},

    name: 'padrao_vida',

    async created() {

        let {id} = this.$route.params;

        let {data: {result: {data: cliente}}} = await get(`cliente/${id}`);

        this.padrao_vida = {
            gastos_fixos: 0,
            lazer: 0,
            seguro_previdencia: 0,
            outros: 0,
            ...cliente.padrao_vida,
            cliente_id: cliente.cliente_id
        };

        this.cliente = cliente;
    },


    computed: {

        porcentagem()
        {
           return parseFloat(this.padrao_vida.porcentagem_responsabilidade || 0);
        },

        somaPorcentagem() {
            return (this.soma * this.porcentagem * 0.01);
        },
        soma() {

            let keys = [
                "gastos_fixos",
                "lazer",
                "seguro_previdencia",
                "outros"
            ];

            let total = 0;


            keys.forEach(key => {

                let num =  parseFloat(this.padrao_vida[key]);

                total += isNaN(num) ? 0 : num;
            });

            return total;
        },

        somaPrazo() {
          return this.somaPorcentagem * (this.padrao_vida.anos_protecao_familia * 12)
        },
    },

    data() {
        return {
            cliente: null,
            padrao_vida: null,
            carregando: false,
        };
    },

    methods: {


        concluir() {

            if (! this.padrao_vida.padrao_vida_id) return;

            this.salvar();
        },

        salvar: debounce(async function() {

            this.carregando = true;

            try{
                await put('padrao-vida', this.padrao_vida);
            } finally {

                setTimeout(() => this.carregando = false, 1500);
            }

        }, 100 )
    }
}
</script>



// WEBPACK FOOTER //
// src/components/clientes/PadraoDeVida.vue